// @flow
import './Collapse.css'

import { Collapse as AntdCollapse } from 'antd'
import * as React from 'react'

export type CollapseItemProps = {
  key: string,
  label: string | React.Node,
  children: React.Node,
  id?: string,
  header?: string | React.Node,
  showArrow?: boolean,
  className?: string,
  isActive?: boolean,
  onItemClick?: (panelKey: React.Key) => void,
  extra?: string | React.Node,
  style?: Object,
}

type Props = {
  items: Array<CollapseItemProps>,
  activeKey?: Array<string | number> | string | number,
  defaultActiveKey?: Array<string | number> | string | number,
  accordion?: boolean,
  onChange?: (key: string | Array<string>) => void,
  className?: string,
  bordered?: boolean,
  expandIconPosition?: 'start' | 'end',
  size?: 'small' | 'middle' | 'large' | void,
}

function Collapse({
  items,
  activeKey,
  defaultActiveKey,
  accordion,
  onChange,
  className,
  bordered,
  expandIconPosition,
  size,
}: Props): React.Node {
  const ref: { current: ?HTMLDivElement } = React.useRef(null)

  return (
    <div ref={ref}>
      <AntdCollapse
        accordion={accordion}
        activeKey={activeKey}
        bordered={bordered}
        className={className}
        defaultActiveKey={defaultActiveKey}
        expandIconPosition={expandIconPosition}
        items={items}
        onChange={onChange}
        size={size}
      />
    </div>
  )
}

export default Collapse
